//mui
import {Box, RadioGroup, Typography} from '@mui/material';
import Radio from '@components/Radio';
//constants
import {BODY2, SUBTITLE2} from '@/utils/constants';
//helpers
import {radioList} from '@/components/Organization/Dashboard/SendEmail/helpers';
//styles
import {sendEmailStyle} from '@/components/Organization/Dashboard/SendEmail/SendEmail.styles';
import {EMAIL_TEMPLATE_TYPE} from '@/utils/enums';

const SendEmail = ({
	selectedEmail,
	setSelectedEmail,
}: {
	selectedEmail: EMAIL_TEMPLATE_TYPE;
	setSelectedEmail: (value: EMAIL_TEMPLATE_TYPE) => void;
}) => {
	return (
		<RadioGroup
			sx={sendEmailStyle.radioGroup}
			aria-labelledby="demo-radio-buttons-group-label"
			defaultValue={EMAIL_TEMPLATE_TYPE.TABLE_UPDATE}
			name="send Email"
		>
			{radioList.map((radio) => (
				<Box
					key={radio.value}
					sx={{...sendEmailStyle.radioItem, ...(selectedEmail === radio.value && sendEmailStyle.selectedRadioItem)}}
				>
					<Radio
						value={radio.value}
						onChange={() => setSelectedEmail(radio.value)}
						label={
							<Box>
								<Typography variant={BODY2}>{radio.label}</Typography>
								<Typography sx={sendEmailStyle.description} variant={SUBTITLE2}>
									{radio.description}
								</Typography>
							</Box>
						}
					/>
				</Box>
			))}
		</RadioGroup>
	);
};

export default SendEmail;
